/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AdminAddressRequest } from '../model';
// @ts-ignore
import { AdminAddressResponse } from '../model';
// @ts-ignore
import { DeliveryAddressCalendarRequest } from '../model';
// @ts-ignore
import { DeliveryAddressCalendarResponse } from '../model';
/**
 * AdminAddressControllerApi - axios parameter creator
 * @export
 */
export const AdminAddressControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userId 
         * @param {AdminAddressRequest} adminAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddressByAdmin: async (userId: string, adminAddressRequest: AdminAddressRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createAddressByAdmin', 'userId', userId)
            // verify required parameter 'adminAddressRequest' is not null or undefined
            assertParamExists('createAddressByAdmin', 'adminAddressRequest', adminAddressRequest)
            const localVarPath = `/admin/users/{userId}/addresses`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddressByAdmin: async (userId: string, addressId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteAddressByAdmin', 'userId', userId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('deleteAddressByAdmin', 'addressId', addressId)
            const localVarPath = `/admin/users/{userId}/addresses/{addressId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressesByAdmin: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAddressesByAdmin', 'userId', userId)
            const localVarPath = `/admin/users/{userId}/addresses`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressesCalendarByAdmin: async (userId: string, startDate: string, endDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAddressesCalendarByAdmin', 'userId', userId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getAddressesCalendarByAdmin', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getAddressesCalendarByAdmin', 'endDate', endDate)
            const localVarPath = `/admin/users/{userId}/addresses/calendar`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} addressId 
         * @param {AdminAddressRequest} adminAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddressByAdmin: async (userId: string, addressId: string, adminAddressRequest: AdminAddressRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateAddressByAdmin', 'userId', userId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('updateAddressByAdmin', 'addressId', addressId)
            // verify required parameter 'adminAddressRequest' is not null or undefined
            assertParamExists('updateAddressByAdmin', 'adminAddressRequest', adminAddressRequest)
            const localVarPath = `/admin/users/{userId}/addresses/{addressId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {DeliveryAddressCalendarRequest} deliveryAddressCalendarRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddressesCalendarByAdmin: async (userId: string, deliveryAddressCalendarRequest: DeliveryAddressCalendarRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateAddressesCalendarByAdmin', 'userId', userId)
            // verify required parameter 'deliveryAddressCalendarRequest' is not null or undefined
            assertParamExists('updateAddressesCalendarByAdmin', 'deliveryAddressCalendarRequest', deliveryAddressCalendarRequest)
            const localVarPath = `/admin/users/{userId}/addresses/calendar`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deliveryAddressCalendarRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAddressControllerApi - functional programming interface
 * @export
 */
export const AdminAddressControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAddressControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {AdminAddressRequest} adminAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAddressByAdmin(userId: string, adminAddressRequest: AdminAddressRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAddressByAdmin(userId, adminAddressRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAddressByAdmin(userId: string, addressId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAddressByAdmin(userId, addressId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddressesByAdmin(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminAddressResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAddressesByAdmin(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddressesCalendarByAdmin(userId: string, startDate: string, endDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeliveryAddressCalendarResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAddressesCalendarByAdmin(userId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} addressId 
         * @param {AdminAddressRequest} adminAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAddressByAdmin(userId: string, addressId: string, adminAddressRequest: AdminAddressRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAddressByAdmin(userId, addressId, adminAddressRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {DeliveryAddressCalendarRequest} deliveryAddressCalendarRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAddressesCalendarByAdmin(userId: string, deliveryAddressCalendarRequest: DeliveryAddressCalendarRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAddressesCalendarByAdmin(userId, deliveryAddressCalendarRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminAddressControllerApi - factory interface
 * @export
 */
export const AdminAddressControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAddressControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {AdminAddressRequest} adminAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddressByAdmin(userId: string, adminAddressRequest: AdminAddressRequest, options?: any): AxiosPromise<AdminAddressResponse> {
            return localVarFp.createAddressByAdmin(userId, adminAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddressByAdmin(userId: string, addressId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAddressByAdmin(userId, addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressesByAdmin(userId: string, options?: any): AxiosPromise<Array<AdminAddressResponse>> {
            return localVarFp.getAddressesByAdmin(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressesCalendarByAdmin(userId: string, startDate: string, endDate: string, options?: any): AxiosPromise<Array<DeliveryAddressCalendarResponse>> {
            return localVarFp.getAddressesCalendarByAdmin(userId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} addressId 
         * @param {AdminAddressRequest} adminAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddressByAdmin(userId: string, addressId: string, adminAddressRequest: AdminAddressRequest, options?: any): AxiosPromise<AdminAddressResponse> {
            return localVarFp.updateAddressByAdmin(userId, addressId, adminAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {DeliveryAddressCalendarRequest} deliveryAddressCalendarRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddressesCalendarByAdmin(userId: string, deliveryAddressCalendarRequest: DeliveryAddressCalendarRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateAddressesCalendarByAdmin(userId, deliveryAddressCalendarRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminAddressControllerApi - object-oriented interface
 * @export
 * @class AdminAddressControllerApi
 * @extends {BaseAPI}
 */
export class AdminAddressControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} userId 
     * @param {AdminAddressRequest} adminAddressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAddressControllerApi
     */
    public createAddressByAdmin(userId: string, adminAddressRequest: AdminAddressRequest, options?: AxiosRequestConfig) {
        return AdminAddressControllerApiFp(this.configuration).createAddressByAdmin(userId, adminAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} addressId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAddressControllerApi
     */
    public deleteAddressByAdmin(userId: string, addressId: string, options?: AxiosRequestConfig) {
        return AdminAddressControllerApiFp(this.configuration).deleteAddressByAdmin(userId, addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAddressControllerApi
     */
    public getAddressesByAdmin(userId: string, options?: AxiosRequestConfig) {
        return AdminAddressControllerApiFp(this.configuration).getAddressesByAdmin(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAddressControllerApi
     */
    public getAddressesCalendarByAdmin(userId: string, startDate: string, endDate: string, options?: AxiosRequestConfig) {
        return AdminAddressControllerApiFp(this.configuration).getAddressesCalendarByAdmin(userId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} addressId 
     * @param {AdminAddressRequest} adminAddressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAddressControllerApi
     */
    public updateAddressByAdmin(userId: string, addressId: string, adminAddressRequest: AdminAddressRequest, options?: AxiosRequestConfig) {
        return AdminAddressControllerApiFp(this.configuration).updateAddressByAdmin(userId, addressId, adminAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {DeliveryAddressCalendarRequest} deliveryAddressCalendarRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAddressControllerApi
     */
    public updateAddressesCalendarByAdmin(userId: string, deliveryAddressCalendarRequest: DeliveryAddressCalendarRequest, options?: AxiosRequestConfig) {
        return AdminAddressControllerApiFp(this.configuration).updateAddressesCalendarByAdmin(userId, deliveryAddressCalendarRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

